module.exports = __webpack_public_path__ + "src/img/artist/artist02.jpg?597ac42f9fb8797207cc57fc90d93ead";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artist02.jpg
// module id = 109
// module chunks = 0